import React, { useEffect, useState } from 'react';
import CustomTextDelayInput from '../../../components/forms/CustomTextDelayInput';
import { FilterOptions } from '../../../hooks/useFilters';

interface OrganisationsFiltersProps {
    updateFilters: (filters: any) => void;
    filters: any;
}

const OrganisationsFilters: React.FC<OrganisationsFiltersProps> = ({ filters, updateFilters }) => {

    const [filter_filters, setFilterFilters] = useState<any>({});
    const [loaded, setLoaded] = useState<boolean>(false);

    useEffect(() => {
        if (loaded && filter_filters !== filters.filter_filters) {
            const delaySearch = setTimeout(() => {
                updateFilters({ ...filter_filters });
            }, 1000);
            return () => clearTimeout(delaySearch);
        }
    }, [filter_filters, loaded]);

    useEffect(() => {
        setFilterFilters(filters.filter_filters || '');
    }, [filters]);

    useEffect(() => {
        setLoaded(true);
    }, []);

    return (
        <>
            <CustomTextDelayInput
                id="search_text"
                label="Buscar"
                placeholder="Buscar por nombre"
                filters={filters}
                updateFilters={updateFilters}
            />

        </>
    );
};

export default OrganisationsFilters;